var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart_card d-block"},[_c('div',{staticClass:"chart_title m-0 justify-content-end"},[_vm._t("chart_title")],2),_c('apexchart',{attrs:{"type":"area","height":"125","width":"100%","options":_vm.areaChartOptions,"series":_vm.areaChartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }